<template>
  <div>
    <div class="nosology" v-if="Nosologys && Nosologys.length">
      <div class="content">
        <div class="nosology__title">Терапевтические области</div>
      </div>
      <Breadcrumbs :pages="[{ name: 'Терапевтические области' }]" />
      <div class="content">
        <div class="nosology__list">
          <NosologyItem
            v-for="(item, ind) in Nosologys"
            :key="ind"
            :item="formattedImageList(item, 'list')"
          />
        </div>
      </div>
    </div>
    <div v-else class="preloader detail-page__preloader">
      <Preloader class="" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumbs from "../components/pageComponents/Breadcrumbs.vue";
import NosologyItem from "../components/pageComponents/NosologyItem.vue";
import Preloader from "@/components/Preloader.vue";
import pageVisit from "@/mixins/pageVisit";
export default {
  metaInfo: {
    title: "Терапевтические области",
  },
  name: "Nosology",
  components: { Breadcrumbs, NosologyItem, Preloader },
  data: () => ({}),
  mixins: [pageVisit],
  computed: {
    ...mapGetters(["Nosologys"]),
  },
  methods: {
    formattedImageList(item, tag) {
      if (item.images && item.images.length) {
        item.image =
          this.$root.host + item.images?.find((el) => el.tag === tag)?.image;
      }
      return item;
    },
    pageVisit(time) {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: "",
          brand_id: "",
          content_date: "",
          content_id: "",
          content_name: "Терапевтические области",
          content_type: "Терапевтические области",
          nosology_name: "",
          content_parameter: "",
          event_type: "visit",
          event_duration: time,
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: "Терапевтические области",
          page_type: "Терапевтические области",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      });
    },
  },
  mounted() {
   
  },
};
</script>

<style lang="scss" scoped>
.nosology {
  padding-top: 64px;
  @media screen and (max-width: 1220px) {
    padding-top: 40px;
  }
  @media screen and (max-width: 767px) {
    padding-top: 32px;
  }
  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;
    color: #1f1f1f;

    @media screen and (max-width: 767px) {
      font-size: 21px;
      line-height: 26px;
    }
  }

  &__list {
    margin-top: 64px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 32px;
    row-gap: 32px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
      margin-top: 40px;
    }

    @media screen and (max-width: 767px) {
      margin-top: 32px;
    }
  }
}
</style>
